import { render, staticRenderFns } from "./ShowMedia.vue?vue&type=template&id=264308c2&scoped=true&"
import script from "./ShowMedia.vue?vue&type=script&lang=js&"
export * from "./ShowMedia.vue?vue&type=script&lang=js&"
import style0 from "./ShowMedia.vue?vue&type=style&index=0&id=264308c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264308c2",
  null
  
)

export default component.exports